import TagManager from '@sooro-io/react-gtm-module';
import { useEffect } from 'react';

import { googleTagManagerContainerId } from '@shared/configs/configs/config';
import { useLayoutViewContext } from '@shared/context';

const useInitGTM = () => {
  const { isMobileView, isPortalView } = useLayoutViewContext();

  useEffect(() => {
    if (isMobileView || isPortalView) {
      window.dataLayer = window.dataLayer || [];
      const tagManagerArgs = {
        gtmId: googleTagManagerContainerId(),
      };
      TagManager.initialize(tagManagerArgs);
      window.dataLayer.push({
        event: 'pageview',
        page: {
          title: window.document.title,
          url: window.location.pathname,
        },
      });
    }
  }, [isMobileView, isPortalView]);
};

export default useInitGTM;
